module.exports = __webpack_public_path__ + "img/robot-outline.3cc5f9b5.svg";